import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppStack from '../../common/AppStack';
import AppCard from '../../common/AppCard';
import classes from '../../../styles/nestedStyles.module.css';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';
import { getRegFormSubmissionStatusInfo } from '../../../helpers/registrationHelper';
import ColoredAvatar from '../../common/ColoredAvatar';

const RegFormSubmissionInfoCard = ({
  regFormSubmission,
  navigateUrl,
  onSelect
}) => {
  const statusInfo = getRegFormSubmissionStatusInfo(regFormSubmission);

  return (
    <AppCard
      key={regFormSubmission.pkRegFormSubmission}
      className={onSelect || navigateUrl ? classes['hover-action-card'] : null}
      component={navigateUrl ? Link : null}
      onClick={
        onSelect && !navigateUrl ? () => onSelect(regFormSubmission) : null
      }
      radius={8}
      style={{ padding: 8 }}
      to={navigateUrl}
      withBorder
    >
      <AppFlexbox style={{ gap: 8 }}>
        <ColoredAvatar
          name={`${regFormSubmission.regPerson.firstName} ${regFormSubmission.regPerson.lastName}`}
          size={42}
          uniqueId={regFormSubmission.user.email}
        />
        <AppFlexbox style={{ flex: 1, justifyContent: 'space-between' }}>
          <AppStack style={{ gap: 0 }}>
            <AppFlexbox style={{ gap: 8 }}>
              <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                {regFormSubmission.regAssociationDivisionForm.regForm.name}
              </AppText>
            </AppFlexbox>

            <AppText
              style={{
                fontSize: 14,
                color: '#666',
                textDecoration: regFormSubmission.regAssociationDivisionOverride
                  ? 'line-through'
                  : 'unset'
              }}
            >
              {
                regFormSubmission.regAssociationDivisionForm
                  .regAssociationDivision.name
              }{' '}
              &middot;{' '}
              {
                regFormSubmission.regAssociationDivisionForm
                  .regAssociationDivision.regAssociationSeason.name
              }
            </AppText>

            {regFormSubmission.regAssociationDivisionOverride && (
              <AppText style={{ fontSize: 14, color: '#666' }}>
                {regFormSubmission.regAssociationDivisionOverride.name} &middot;{' '}
                {
                  regFormSubmission.regAssociationDivisionOverride
                    .regAssociationSeason.name
                }
              </AppText>
            )}

            <AppText style={{ fontSize: 14, color: '#666' }}>
              {regFormSubmission.regPerson.firstName}{' '}
              {regFormSubmission.regPerson.lastName}
            </AppText>
          </AppStack>

          <AppFlexbox>
            <Badge
              color={statusInfo.color}
              variant={statusInfo.variant || 'filled'}
            >
              {statusInfo.label}
            </Badge>
          </AppFlexbox>
        </AppFlexbox>
      </AppFlexbox>
    </AppCard>
  );
};

RegFormSubmissionInfoCard.propTypes = {
  navigateUrl: PropTypes.string,
  onSelect: PropTypes.func,
  regFormSubmission: PropTypes.object
};

export default RegFormSubmissionInfoCard;
